import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import SupplierContainer from 'app/containers/InventoryManagement/Supplier'

const SupplierContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <SupplierContainer />
    </>
  )
}
const SupplierContainerPage = memo(SupplierContainerPageCpn, isEqual)

export default SupplierContainerPage
